import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsVisionApi,
  IAboutUsVisionApiRequest,
  IAboutUsVisionApiGetAllAttrs,
  IAboutUsVisionApiGetAllResponse,
  IAboutUsVisionApiGetAttrs,
  IAboutUsVisionApiGetResponse,
  IAboutUsVisionApiSaveAttrs,
  IAboutUsVisionApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/vision/about-us-vision-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsVisionApi extends BaseApi<IAboutUsVisionApi> implements IAboutUsVisionApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_VISION_URL
  private aboutUsVisionUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home banners
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsVisionApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsVisionApiGetAllResponse>} Promise<IAboutUsVisionApiGetAllResponse>
   */
  async aboutUsVision_getAboutUsVisions(payload: IAboutUsVisionApiGetAllAttrs): Promise<IAboutUsVisionApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsVisionUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsVisionApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsVisionApiGetResponse>} Promise<IAboutUsVisionApiGetResponse>
   */
  async aboutUsVision_getAboutUsVision(payload: IAboutUsVisionApiGetAttrs): Promise<IAboutUsVisionApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsVisionUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsVisionApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsVisionApiSaveResponse>} Promise<IAboutUsVisionApiSaveResponse>
   */
  async aboutUsVision_saveAboutUsVision(payload: IAboutUsVisionApiSaveAttrs): Promise<IAboutUsVisionApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id ? `${this.aboutUsVisionUrl}/update/${payload.params.id}` : `${this.aboutUsVisionUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
